/**
 * Ring-by-amount helpers (fuel / pump dollar entry).
 */

export const QUANTITY_SCALE = 4

export function roundExtendedPrice (value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return 0
  return Math.round(n * 100) / 100
}

export function quantityFromExtendedPrice (extendedPrice, unitPrice) {
  const ext = roundExtendedPrice(extendedPrice)
  const unit = Number(unitPrice)
  if (!Number.isFinite(ext) || !Number.isFinite(unit) || unit <= 0) return 0
  const factor = 10 ** QUANTITY_SCALE
  return Math.round((ext / unit) * factor) / factor
}

export function isRingByAmountLine (item) {
  return !!(item?.metadata?.ring_by_amount || item?.ring_by_amount)
}

export function extendedPriceFromCartLine (item) {
  if (!item) return null
  const meta = item.metadata || {}
  if (meta.ring_by_amount && meta.extended_price != null) {
    return roundExtendedPrice(meta.extended_price)
  }
  return null
}

export function lineExtendedPriceBase (item) {
  const fromMeta = extendedPriceFromCartLine(item)
  if (fromMeta != null) return fromMeta
  return (Number(item?.price) || 0) * (Number(item?.quantity) || 0)
}
